'use strict';

var base = require('base/product/base');
var tealiumEnable = require('int_tealium_sfra/tealiumEnable');
var cartCustomService = require('./cartCustomService');
var utils = require('base_global/utils');    // Antavo custom
var constants = require('base_global/constants');    // Antavo custom
var handleReward = require('antavo_custom/handleReward');
var klarnaExpress = require('klarna_express/klarnaExpressButton');
var sessionExpiry = require('base_global/sessionExpired');  // Antavo custom
var DOMPurify = require('dompurify');
var verifyOOSIfRequired = require('./verifyOOS').verifyOOSIfRequired;
/**
 * Handles bonus product redirection
 * @param {Object} $this - Element
 */
function bonusProductRedirection($this) {
    if ($this.parents('.product-info').hasClass('bonus-product-line-item') && $('.cart-page').length) {
        location.reload();
    }
}

/**
 * function to remove giftbox border if no wishlist item
 */
function giftboxNoBorder() {
    var wishlistCount = $('.save-for-later__list .card.product-info').length;
    if (wishlistCount === 0) {
        $('.shopping-bag').addClass('noborder-giftbox');
    } else {
        $('.shopping-bag').removeClass('noborder-giftbox');
    }
}

/**
 * cart count abel
 * @param {string} cartCount - cartCount
 */
function orderSummeryItemLabel(cartCount) {
    if (cartCount > 1) {
        $('.order-summary-inner').removeClass('single-cart-item').addClass('multi-cart-item');
    } else {
        $('.order-summary-inner').removeClass('multi-cart-item').addClass('single-cart-item');
    }
}

/**
 * Updates details of a product line item
 * @param {Object} data - AJAX response from the server
 * @param {string} uuid - The uuid of the product line item to update
 */
function updateProductDetails(data, uuid) {
    var cartHeaderTotalItemsLabel = $('.cart-header-total-items').val();
    var cartHeaderTotalItemLabel = $('.cart-header-single-item').val();
    var cartHeaderCountLabel = data.cartModel.numItems > 1 ? cartHeaderTotalItemsLabel : cartHeaderTotalItemLabel;
    $('.card.product-info.uuid-' + uuid).replaceWith(data.renderedTemplate);
    $('.cart-header__description', '.shopping-bag').html(DOMPurify.sanitize(cartHeaderCountLabel.replace('{0}', data.cartModel.numItems)));
    $('.cart-header__description').attr('data-tealiumitemquantity', data.cartModel.numItems);
    let cartItemCount = data.cartModel.numItems > 1 ? '(' + data.cartModel.numItems + ' items)' : '(' + data.cartModel.numItems + ' item)';
    $('.order-summary__title .summary-item-count').empty().append(cartItemCount);
    orderSummeryItemLabel(data.cartModel.numItems);
    var cartModel = data.cartModel;
    cartCustomService.updateProductImage(cartModel);

    giftboxNoBorder();
}

/**
 * Updates the product cart delete
 * @param {Object} data - AJAX response
 * @param {Object} uuid - AJAX response
 */
function cartDeleteConfirmationWithItems(data, uuid) {
    if (data.toBeDeletedUUIDs && data.toBeDeletedUUIDs.length > 0) {
        for (var i = 0; i < data.toBeDeletedUUIDs.length; i++) {
            $('.uuid-' + data.toBeDeletedUUIDs[i]).remove();
        }
    }

    // Remove product line item from cart page
    $('.uuid-' + uuid).remove();
    if (!data.basket.hasBonusProduct) {
        $('.bonus-product').remove();
    }
    if (!data.basket.isGiftEligible && !data.basket.alreadyGiftboxAdded) {
        $('.gift-point-send').addClass('d-none');
        if (!data.giftoptionData.sendInGiftBox && (data.giftoptionData.hidePrice || data.giftoptionData.onlyIncludedGiftNote)) {
            $('.gift-image').addClass('d-none');
            if (data.giftoptionData.giftPrice === 'Free') {
                $('.gift-price').addClass('gift-price-free');
            } else {
                $('.gift-price').removeClass('gift-price-free');
            }
            $('.gift-price').empty().html(data.giftoptionData.giftPrice);
            $('.gift-title-price-text .sendInGiftOptions').removeClass('d-none');
            $('.gift-title-price-text .sendInGiftBox').addClass('d-none');
            $('.gift-title-price-text .sendInGiftBox').removeClass('d-inline');
        } else {
            $('.gift-box--form, .gift__card').addClass('d-none');
            $('.gift-box').removeClass('d-none');
            $('.gift-option-form').trigger('reset');
            if ($('#giftNoteCheck').is(':checked')) {
                $('.gift-box--note').removeClass('d-none');
            } else {
                $('.gift-box--note, .btn-git-box-submit').addClass('d-none');
            }
        }
    }

    if ($('.js-product--list').length) {
        $('.js-product--list').html(data.renderTemplate);
    }

    // revalidate cart when product line item removed
    cartCustomService.updateCouponsAndPromos(data.basket.totals.discountsHtml);
    cartCustomService.updateCartTotals(data.basket);
    cartCustomService.updateApproachingDiscounts(data.basket.approachingDiscounts);
    cartCustomService.validateBasket(data.basket);
    handleReward.rewardsResponse(data);
    $('body').trigger(constants.events.SET_SHIPPING_METHOD_SELECTION, data.basket);
}

/**
 * Replace content of modal
 * @param {string} actionUrl - url to be used to remove product
 * @param {string} productID - pid
 * @param {string} productName - product name
 * @param {string} uuid - uuid
 */
function confirmDelete(actionUrl, productID, productName, uuid) {
    var $deleteConfirmBtn = $('.cart-delete-confirmation-btn');
    var $productToRemoveSpan = $('.product-to-remove');
    $deleteConfirmBtn.data('pid', productID);
    $deleteConfirmBtn.data('action', actionUrl);
    $deleteConfirmBtn.data('uuid', uuid);
    $productToRemoveSpan.empty().append(productName);
}

/**
 * Show msg on cart page when edit order option is clicked
 */
function showEditOrderMsg() {
    let params = utils.getQueryStringParams(window.location.href);
    if (params.editMsg1 && params.editMsg2) {
        utils.showConfirmToast(params.editMsg1);
    }
    if (params.editErrorMsg) {
        $('#maincontent .ds-cart-edit-order-msg').append(
            '<p class="oneditOrderErrMsg">' + params.editErrorMsg + '</p>'
        );
    }
}

/**
 * Show msg on cart page when rewards applied is not available
 */
function showRewardsUnavailableMsg() {
    $('.rewards-redeem-error').removeClass('d-none');
    var currentUrl = window.location.href;
    window.history.replaceState({}, document.title, currentUrl.substring(0, currentUrl.indexOf('?')));
}

/**
 * Show msg on cart page when rewards applied is not available
 */
function showRewardsErrorMsg() {
    $('.rewards-technical-error').removeClass('d-none');
    var currentUrl = window.location.href;
    window.history.replaceState({}, document.title, currentUrl.substring(0, currentUrl.indexOf('?')));
}

/**
 * Show msg on cart page when rewards applied is not available
 */
function showServiceErrorMsg() {
    $('.rewards-service-error').removeClass('d-none');
    var currentUrl = window.location.href;
    window.history.replaceState({}, document.title, currentUrl.substring(0, currentUrl.indexOf('?')));
}

/**
 * @param {number} totals - totals
 */
function initializePaymentMethods(totals) {
    if ($('#checkout-main').length && ($('#checkout-main').attr('data-checkout-stage') === 'payment')) {
        var summaryHelpers = require('base_global/checkout/summary');
        var adyenCheckout = require('adyen_custom/adyen/checkout');
        summaryHelpers.updateTotals(totals);
        adyenCheckout.init();
    }
}

/**
 * Remove Product from carts
 * @param {Object} productDetails productdetails to pass to url
 * @param {Object} options contailing actionUrl controller endpoint
 * @param {function} callback callback function
 */
function removeProductById(productDetails, options, callback) {
    const url = utils.appendToUrl(options.actionUrl, productDetails);
    const defaultOptions = Object.assign({
        containerClass: 'cart',
        pageType: 'cart',
        emptyClassName: 'cart-empty',
        className: 'has-cart-items cart-page',
        action: 'remove'
    }, options);
    const $container = $(`.${defaultOptions.containerClass}`);
    const $mainRecs = $('.cart-main-recommendations');
    const $emptyRecs = $('.cart-empty-recommendations');
    var $summaryMsg = $('.signin-pts');
    $('body > .modal-backdrop').remove();
    $('body').trigger(constants.events.CART_BEFORE_UPDATE);
    $.ajax({
        url: url,
        type: 'get',
        dataType: 'json',
        success: function (data) {
            verifyOOSIfRequired(data, function (updatedData) {
                data = updatedData; // eslint-disable-line
                if (data.basket.items.length === 0) {
                    $container.removeClass(defaultOptions.className).addClass(defaultOptions.emptyClassName);
                    $summaryMsg.addClass('no-items');

                    // call during remove action to remove toast when all items are removed
                    if (defaultOptions.action === 'remove') {
                        $('.valid-cart-error').addClass('d-none');
                    }

                    if (defaultOptions.pageType === 'cart') {
                        $container.removeClass('has-cart-items');
                        $('.shipping--intro').addClass('d-none');
                        $('.page.cart').removeClass('empty-cart-antavopoints').addClass('empty-cart-antavopoints');
                    }

                    cartCustomService.updateMiniCart(data.basket);
                    cartCustomService.resetMiniCartPopover();

                    $('body').removeClass('modal-open');
                    $('html').removeClass('veiled');
                    data.basket.action = 'Cart'; // eslint-disable-line
                    if ($('.js-product--list').length) {
                        if (data.basket.items.length) {
                            $('.js-product--list').html(data.renderTemplate);
                        } else {
                            const $targetContainer = $('.emptycart-ooslist');
                            $targetContainer.html(data.renderTemplate);
                            const $cartPage = $('.cart');
                            $cartPage.removeClass('has-cart-items, cart-page');
                            $('.shipping--intro').addClass('d-none');
                            $cartPage.addClass('cart-empty');
                        }
                        cartCustomService.updateCartComponents(data.basket);
                    }
                    cartCustomService.updateCartTotals(data.basket);
                    cartCustomService.updateApproachingDiscounts(data.basket.approachingDiscounts);
                    cartCustomService.validateBasket(data.basket);
                    initializePaymentMethods(data.basket.totals);
                    // Antavo Loyalty start
                    if (data.basket.antavoRewardPoints && data.basket.antavoRewardPoints.points >= 0) {
                        $('.tooltip-wrapper .tooltip-points').empty().append('Members earn points ' + data.basket.antavoRewardPoints.points + ' Preferred Loyalty points on this purchase.');
                        $('.loyalty-info-message-points').val(data.basket.antavoRewardPoints.points);
                        $('.reward-earned-payment').html(data.basket.antavoRewardPoints.points);
                        $('.order-summary-container .loyalty-rewards-box-model-cart .points-display, .device-summary-msg .loyalty-rewards-box-model-cart .points-display').html(data.basket.antavoRewardPoints.points);
                        $('.order-summary-container, .device-loyalty-pointscontainer').removeClass('hide-antavo-copy');
                        if ($('.loyalty-info-message .checkout-loyaltyrewards-container').length) {
                            $('.loyalty-info-message .checkout-loyaltyrewards-container').removeClass('hide-antavo-copy');
                        }
                        if (data.basket.antavoRewardPoints.points === 0) {
                            $('.order-summary-container, .device-loyalty-pointscontainer').addClass('hide-antavo-copy');
                            if ($('.loyalty-info-message .checkout-loyaltyrewards-container').length) {
                                $('.loyalty-info-message .checkout-loyaltyrewards-container').addClass('hide-antavo-copy');
                            }
                        }
                    }
                } else {
                    $container
                        .removeClass(defaultOptions.emptyClassName)
                        .addClass(defaultOptions.className);
                    cartDeleteConfirmationWithItems(data, productDetails.uuid);
                    $('.page.cart').removeClass('empty-cart-antavopoints');
                }
                if ( data.basket.items.length > 0) { // eslint-disable-line
                    $mainRecs.removeClass('d-none');
                    $emptyRecs.addClass('d-none');
                } else {
                    $mainRecs.addClass('d-none');
                    $emptyRecs.removeClass('d-none');
                }
                // Disabled Estimated Total Sticky in case of one product
                var wishlistCount = $('.save-for-later__list .card.product-info').length;
                var orderSummeryFlag = $('.estTotal-sticky-container').hasClass('estTotal-sticky');
                if (data.basket.items.length > 0 && (data.basket.items.length + wishlistCount) >= 2 && !orderSummeryFlag) {
                    $('.estTotal-sticky-container').addClass('estTotal-sticky');
                } else if (data.basket.items.length === 1 && wishlistCount === 0 && orderSummeryFlag) {
                    $('.estTotal-sticky-container').removeClass('estTotal-sticky');
                }

                if ($('div.ds-cart-error-messaging').length && !data.basket.valid.mExclusiveError) {
                    $('.cart-exclusive-member-error').addClass('d-none');
                    $('.buttonErrorMessage').addClass('d-none');
                }

                var noQtyError = !data.basket.qtyValid || (data.basket.qtyValid && !data.basket.qtyValid.error);
                if ($('div.ds-cart-error-messaging').length && !data.basket.valid.error && noQtyError) {
                    $('.cart-error-messaging').addClass('d-none');
                    $('.buttonErrorMessage').addClass('d-none');
                } else if ($('div.ds-cart-error-messaging').length && !noQtyError) {
                    $('.cart-qty-error .cart-error_message').empty().append(data.basket.qtyValid.message);
                    $('.cart-qty-error').removeClass('d-none');
                    $('html, body').animate({ scrollTop: 0 }, 200);
                }
                var cartHeaderTotalItemsLabel = $('.cart-header-total-items').val();
                var cartHeaderTotalItemLabel = $('.cart-header-single-item').val();
                var cartHeaderCountLabel = data.basket.numItems > 1 ? cartHeaderTotalItemsLabel : cartHeaderTotalItemLabel;
                $('.cart-header__description', '.shopping-bag').html(DOMPurify.sanitize(cartHeaderCountLabel.replace('{0}', data.basket.numItems)));
                $('.cart-header__description').attr('data-tealiumitemquantity', data.basket.numItems);
                $('.minicart-quantity').empty().append(data.basket.numItems);
                let cartItemCount = data.basket.numItems > 1 ? '(' + data.basket.numItems + ' items)' : '(' + data.basket.numItems + ' item)';
                $('.order-summary__title .summary-item-count').empty().append(cartItemCount);
                orderSummeryItemLabel(data.basket.numItems);
                giftboxNoBorder();
                $('body').trigger(constants.events.CART_UPDATED, data);

                if (data.basket && data.basket.cartAnalyticsData && data.basket.checkoutAnalyticsPriceAndSize) {
                    $('.checkoutanalyticscta').data('checkoutanalyticsdata', { cartAnalyticsData: data.basket.cartAnalyticsData, priceAndSize: data.basket.checkoutAnalyticsPriceAndSize });
                }
                if (data.basket && data.basket.totals && data.basket.totals.errorCodes && data.basket.totals.errorCodes.length > 0) {
                    tealiumEnable.getAnalyticsData('miniCartRemoveAnalytics', data.deletedPliAnalyticsData, data.basket.totals.errorCodes);
                } else {
                    tealiumEnable.getAnalyticsData('miniCartRemoveAnalytics', data.deletedPliAnalyticsData);
                }
                tealiumEnable.getAnalyticsData('cartAutoUpdateProductEvent', data);
                if (typeof callback === 'function') callback(data);
            });
        },
        error: function (err) {
            if (err.responseJSON.redirectUrl) {
                window.location.href = err.responseJSON.redirectUrl;
            } else {
                utils.createErrorNotification(err.responseJSON.errorMessage);
                $.spinner().stop();
            }
        }
    });
}

/**
 * cart quantity stepper behavior
 * @param {Object} item  - item
 */
function updateListQuantity(item) {
    let quantityInput = $(item).siblings('.quantity');
    let selectedQuantity = $(quantityInput).val();
    selectedQuantity = Math.round(selectedQuantity);

    if ($(item).hasClass('qty-plus')) { // eslint-disable-line
        selectedQuantity += 1;
    } else if ($(item).hasClass('qty-minus')) { // eslint-disable-line
        selectedQuantity -= 1;
    }

    selectedQuantity = selectedQuantity < 0 ? 0 : selectedQuantity;
    $(quantityInput).val(selectedQuantity).trigger('change', true);
}


const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        const $checkoutButtonWrapper = $('.checkoutButtonWrapper');
        if (entry.isIntersecting || entry.boundingClientRect.top < 0) {
            $checkoutButtonWrapper.removeClass('stickyCheckoutButton');
        } else {
            $checkoutButtonWrapper.addClass('stickyCheckoutButton');
        }
    });
});

module.exports = function () {
    var currentPage = $('.page').data('page');
    var queryParam = utils.getQueryStringParams(window.location.href);
    if ((($('.cart-empty').length && !$('.cart-empty').data('autenticateduser')) && cookieSet.get('rememberMe') === 'false') || queryParam.login === 'true') { // eslint-disable-line
        setTimeout(() => {
            if ($('#checkout-section').length > 0) {
                $('#checkout-section .initiate-checkout_js').trigger('click');
            } else {
                $('#returnToSignIn').trigger('click');
            }
        }, 500);
    }
    const $checkoutSection = document.getElementById('checkout-section');
    if ($checkoutSection) {
        observer.observe($checkoutSection);
    }
    sessionExpiry();
    $('body').on('click', '.remove-product', function (e) {
        e.preventDefault();
        var actionUrl = $(this).data('action');
        var productID = $(this).data('pid');
        var productName = $(this).data('name');
        var uuid = $(this).data('uuid');
        var toastMessage = $(this).data('toastmsg');
        $('.cartmerge-error').addClass('d-none');
        confirmDelete(actionUrl, productID, productName, uuid);
        setTimeout(() => {
            utils.showConfirmToast(toastMessage);
        }, 200);
        if ($('.rewardlimitmessagewrapper').length) {
            $('.rewardlimitmessagewrapper').addClass('hide');
        }
        utils.uniformSpacing();
    });

    $('body').on(constants.events.CART_ITEM_UPDATED, function (e, data, uuid) {
        cartCustomService.updateCouponsAndPromos(data.cartModel.totals.discountsHtml);
        cartCustomService.updateCartTotals(data.cartModel);
        cartCustomService.updateApproachingDiscounts(data.cartModel.approachingDiscounts);
        cartCustomService.updateAvailability(data.cartModel, uuid);
        cartCustomService.validateBasket(data.cartModel);
        cartCustomService.cartCheckoutShowHideItems();
        handleReward.rewardsResponse(data);
        updateProductDetails(data, uuid);

        if (data.uuidToBeDeleted) {
            $('.uuid-' + data.uuidToBeDeleted).remove();
        }

        $('.checkoutanalyticscta').data('checkoutanalyticsdata', { cartAnalyticsData: data.cartModel.cartAnalyticsData, priceAndSize: data.cartModel.checkoutAnalyticsPriceAndSize });
        $('.cart-header__description').attr('data-tealiumitemquantity', data.cartModel ? data.cartModel.numItems : null);
        let cartItemCount = data.cartModel.numItems > 1 ? '(' + data.cartModel.numItems + ' items)' : '(' + data.cartModel.numItems + ' item)';
        $('.order-summary__title .summary-item-count').empty().append(data.cartModel ? cartItemCount : null);
        orderSummeryItemLabel(data.cartModel ? data.cartModel.numItems : null);
        giftboxNoBorder();
        utils.uniformSpacing();
    });
    $('body').on(constants.events.CART_ITEM_REMOVED, function (e, data) {
        e.preventDefault();
        confirmDelete(data.actionUrl, data.productID, data.productName, data.uuid);
        utils.uniformSpacing();
    });

    $('body').off(constants.events.CART_ITEM_SAVEDFORLATER).on(constants.events.CART_ITEM_SAVEDFORLATER, function (event, productDetails, cb) {
        const $removeProduct = $(`.remove-product[data-pid=${productDetails.pid}]`);
        const actionUrl = $removeProduct.data('action') + '?pageType=cart';
        removeProductById(productDetails, {
            actionUrl
        }, cb);
        utils.uniformSpacing();
    });

    $('body').off(constants.events.PRODUCT_ADDTOCART).on(constants.events.PRODUCT_ADDTOCART, function (event, data) {
        if (data.cart.items.length) {
            $('.cart').removeClass('cart-empty').addClass('cart-page');
            cartCustomService.updateMiniCart(data.cart);
            cartCustomService.updateCartTotals(data.cart);
            cartCustomService.updateApproachingDiscounts(data.cart.approachingDiscounts);
            cartCustomService.validateBasket(data.cart);
            $('body').trigger(constants.events.SET_SHIPPING_METHOD_SELECTION, data.cart);
        } else {
            $('.cart').removeClass('cart-page').addClass('cart-empty');
        }
        utils.uniformSpacing();
    });

    $('.optional-promo').on('click', function (e) {
        e.preventDefault();
        $('.promo-code-form').toggle();
    });

    $('body').on('click', '.cart-delete-confirmation-btn', function (e) {
        e.preventDefault();
        var productID = $(this).attr('data-pid');
        var actionUrl = $(this).attr('data-action') + '?pageType=cart';
        var uuid = $(this).attr('data-uuid');

        var productDetails = {
            pid: productID,
            uuid: uuid
        };

        removeProductById(productDetails, {
            actionUrl,
            action: 'remove'
        });
        if ($('.rewardlimitmessagewrapper').length) {
            $('.rewardlimitmessagewrapper').addClass('hide');
        }
        utils.uniformSpacing();
    });

    // code for cart page new quantity stepper
    $('body').on('click', '.qty-plus, .qty-minus', function () {
        updateListQuantity(this);
    });

    $('body').on('change', '.quantity-form > .quantity', function () {
        var quantity = $(this).val();
        var uuid = $(this).data('uuid');
        $('.cartmerge-error').addClass('d-none');
        if (quantity === '0') {
            $('.cart-delete-confirmation-btn').each(function () {
                if ($(this).attr('data-uuid') === uuid) {
                    $(this).trigger('click');
                    return false;
                }
                return true;
            });
        } else {
            var preSelectQty = $(this).data('pre-select-qty');
            var productID = $(this).data('pid');
            var url = $(this).data('action');

            var urlParams = {
                pid: productID,
                quantity: quantity,
                uuid: uuid
            };
            url = utils.appendToUrl(url, urlParams);

            $(this).parents('.card').spinner().start();

            $('body').trigger(constants.events.CART_BEFORE_UPDATE);

            $.ajax({
                url: url,
                type: 'get',
                context: this,
                dataType: 'json',
                success: function (data) {
                    var $this = $(this);
                    verifyOOSIfRequired(data, function (updatedData) {
                        data = updatedData; // eslint-disable-line
                        if ($('.initiate-checkout_js').hasClass('disabled')) {
                            $this.removeClass('disabled');
                        }

                        $('.quantity[data-uuid="' + uuid + '"]').val(quantity);
                        $('.qty-error-' + uuid).find('button').trigger('click');

                        cartCustomService.updateCouponsAndPromos(data.totals.discountsHtml);
                        cartCustomService.updateCartTotals(data);
                        cartCustomService.updateApproachingDiscounts(data.approachingDiscounts);
                        cartCustomService.updateAvailability(data, uuid);
                        cartCustomService.validateBasket(data);
                        cartCustomService.updateProductImage(data);
                        cartCustomService.cartCheckoutShowHideItems();
                        var noQtyError = !data.qtyValid || (data.qtyValid && !data.qtyValid.error);
                        if (!data.valid.error && noQtyError && $('.cart-error-messaging')) {
                            $('.cart-error-messaging').addClass('d-none');
                            $('.buttonErrorMessage').addClass('d-none');
                        } else if ($('div.ds-cart-error-messaging').length && !noQtyError) {
                            $('.cart-qty-error .cart-error_message').empty().append(data.qtyValid.message);
                            $('.cart-qty-error').removeClass('d-none');
                            $('html, body').animate({ scrollTop: 0 }, 200);
                        }
                        $this.data('pre-select-qty', quantity);
                        $('body').trigger(constants.events.CART_UPDATED, data);
                        $.spinner().stop();
                        bonusProductRedirection($this);
                        $('.checkoutanalyticscta').data('checkoutanalyticsdata', { cartAnalyticsData: data.cartAnalyticsData, priceAndSize: data.checkoutAnalyticsPriceAndSize });
                        tealiumEnable.getAnalyticsData('miniCartAddOrSubtractEvent', data, { pid: productID, quantityUpdate: (quantity - preSelectQty).toString() });
                        tealiumEnable.getAnalyticsData('cartAutoUpdateProductEvent', data);
                        var cartHeaderTotalItemsLabel = $('.cart-header-total-items').val();
                        var cartHeaderTotalItemLabel = $('.cart-header-single-item').val();
                        var cartHeaderCountLabel = data.numItems > 1 ? cartHeaderTotalItemsLabel : cartHeaderTotalItemLabel;
                        $('.cart-header__description', '.shopping-bag').html(DOMPurify.sanitize(cartHeaderCountLabel.replace('{0}', data.numItems)));
                        $('.cart-header__description').attr('data-tealiumitemquantity', data.numItems);
                        let cartItemCount = data.numItems > 1 ? '(' + data.numItems + ' items)' : '(' + data.numItems + ' item)';
                        $('.order-summary__title .summary-item-count').empty().append(cartItemCount);
                        orderSummeryItemLabel(data.numItems);
                        giftboxNoBorder();

                        if ($('.rewardlimitmessagewrapper').length) {
                            $('.rewardlimitmessagewrapper').addClass('hide');
                        }
                        utils.uniformSpacing();
                    });
                },
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        if (!$('.qty-error-' + uuid).length > 0) {
                            $('.ds-cart-error-messaging').addClass('ds-cart-error__transition');
                            // var errorMsg = $('.uuid-' + uuid).find('.line-item-name').html();
                            // var message = err.responseJSON.message.prefix + errorMsg + err.responseJSON.message.suffix;
                            // var errorHtml = '<div class="alert alert-danger alert-dismissible valid-cart-error ' +
                            //     'fade show qty-error-' + uuid + '" role="alert">' +
                            //     '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' +
                            //     '<span aria-hidden="true">&times;</span>' +
                            //     '</button>' + message + '</div>';
                            // $('.cart-error').html(errorHtml);
                        }
                        if (err.responseJSON.message) {
                            utils.showErrorToast(err.responseJSON.message);
                        }
                        $(this).val(parseInt(preSelectQty, 10));
                        tealiumEnable.getAnalyticsData('serverError', err.responseJSON.errorCode);
                        $.spinner().stop();
                    }
                }
            });
        }
    });

    $('.shippingMethods').on('change', function () {
        var url = $(this).attr('data-actionUrl');
        var urlParams = {
            methodID: $(this).find(':selected').attr('data-shipping-id')
        };

        $('.totals').spinner().start();
        $('body').trigger(constants.events.CART_BEFORE_SHIPPING_METHOD_SELECTED);
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: urlParams,
            success: function (data) {
                if (data.error) {
                    window.location.href = data.redirectUrl;
                } else {
                    cartCustomService.updateCouponsAndPromos(data.totals.discountsHtml);
                    cartCustomService.updateCartTotals(data);
                    cartCustomService.updateApproachingDiscounts(data.approachingDiscounts);
                    cartCustomService.validateBasket(data);
                }

                $('body').trigger(constants.events.CART_SHIPPING_METHOD_SELECTED, data);
                $.spinner().stop();
            },
            error: function (err) {
                if (err.redirectUrl) {
                    window.location.href = err.redirectUrl;
                } else {
                    utils.createErrorNotification(err.responseJSON.errorMessage);
                    $.spinner().stop();
                }
            }
        });
    });

    $('.promo-code-form').on('submit', function (e) {
        e.preventDefault();
        $.spinner().start();
        $('.coupon-missing-error').hide();
        $('.coupon-error-message').empty();
        if (!$('.coupon-code-field').val()) {
            $('.promo-code-form .form-control').addClass('is-invalid');
            $('.promo-code-form .form-control').attr('aria-describedby', 'missingCouponCode');
            $('.coupon-missing-error').show();
            $.spinner().stop();
            return false;
        }
        var $form = $('.promo-code-form');
        $('.promo-code-form .form-control').removeClass('is-invalid');
        $('.coupon-error-message').empty();
        $('body').trigger(constants.events.PROMOTION_BEFORE_UPDATE);

        $.ajax({
            url: $form.attr('action'),
            type: 'GET',
            dataType: 'json',
            data: $form.serialize(),
            success: function (data) {
                if (data.error) {
                    $('.promo-code-form .form-control').addClass('is-invalid');
                    $('.promo-code-form .form-control').attr('aria-describedby', 'invalidCouponCode');
                    $('.coupon-error-message').empty().append(data.errorMessage);
                    $('body').trigger(constants.events.PROMOTION_ERROR, data);
                } else {
                    cartCustomService.updateCouponsAndPromos(data.totals.discountsHtml);
                    cartCustomService.updateCartTotals(data);
                    cartCustomService.updateApproachingDiscounts(data.approachingDiscounts);
                    cartCustomService.validateBasket(data);
                    $('.js-product--list').html(data.renderTemplate);
                    $('body').trigger(constants.events.PROMOTION_SUCCESS, data);
                }
                $('.coupon-code-field').val('');
                $.spinner().stop();
            },
            error: function (err) {
                $('body').trigger(constants.events.PROMOTION_ERROR, err);
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    utils.createErrorNotification(err.errorMessage);
                    $.spinner().stop();
                }
            }
        });
        return true;
    });

    $('body').on('click', '.cart-page .bonus-product-button', function () {
        $.spinner().start();
        $(this).addClass('launched-modal');
        $.ajax({
            url: $(this).data('url'),
            method: 'GET',
            dataType: 'json',
            success: function (data) {
                base.methods.editBonusProducts(data);
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    });

    $('body').on('hidden.bs.modal', '#chooseBonusProductModal', function () {
        $('#chooseBonusProductModal').remove();
        $('.modal-backdrop').remove();
        $('body').removeClass('modal-open');

        if ($('.cart-page').length) {
            $('.launched-modal .btn-outline-primary').trigger('focus');
            $('.launched-modal').removeClass('launched-modal');
        } else {
            $('.product-detail .add-to-cart').focus();
        }
    });

    $('body').on(constants.events.PRODUCT_UPDATE_AVAILABILITY, function (e, response) {
        // bundle individual products
        $('.product-availability', response.$productContainer)
            .data('ready-to-order', response.product.readyToOrder)
            .data('available', response.product.available)
            .find('.availability-msg')
            .empty()
            .html(response.message);


        var dialog = $(response.$productContainer)
            .closest('.quick-view-dialog');

        if ($('.product-availability', dialog).length) {
            // bundle all products
            var allAvailable = $('.product-availability', dialog).toArray()
                .every(function (item) { return $(item).data('available'); });

            var allReady = $('.product-availability', dialog).toArray()
                .every(function (item) { return $(item).data('ready-to-order'); });

            $('.global-availability', dialog)
                .data('ready-to-order', allReady)
                .data('available', allAvailable);

            $('.global-availability .availability-msg', dialog).empty()
                .html(allReady ? response.message : response.resources.info_selectforstock);
        } else {
            // single product
            $('.global-availability', dialog)
                .data('ready-to-order', response.product.readyToOrder)
                .data('available', response.product.available)
                .find('.availability-msg')
                .empty()
                .html(response.message);
        }
    });

    $('body').on('click', '.checkout-options .applepay-container', function () {
        // GDC-11719 - to capture the applepay express checkout from cart
        var checkoutMethod = 'applepay';
        var subTotal = $('.totals .sub-total').html();
        var totalItems = $('.cart-header__description').data('tealiumitemquantity');
        var initiateCheckoutData = $('.checkoutanalyticscta').data('checkoutanalyticsdata');
        tealiumEnable.getAnalyticsData('initiateRegularCheckout', checkoutMethod, initiateCheckoutData, subTotal, totalItems);
    });

    $('body').on('click', '#checkout-section .initiate-checkout_js, .initiate-checkout_js-remembered-guest-user', function () {
        // eslint-disable-next-line no-unused-vars
        var querystring;
        var rememberedGuestUser = $(this).hasClass('initiate-checkout_js-remembered-guest-user');
        if (rememberedGuestUser) {
            querystring = 'rememberedGuestUser';
        }
        if ($(this).hasClass('disabled')) {
            $('.buttonErrorMessage').removeClass('d-none');
            return false;
        }
        var checkoutMethod = 'guest checkout';
        if ($(this).data('autenticateduser') === true) {
            checkoutMethod = 'logged in checkout';
        }
        var $this = $(this);
        var subTotal = $('.totals .sub-total').html();
        var totalItems = $('.cart-header__description').data('tealiumitemquantity');
        var initiateCheckoutData = $('.checkoutanalyticscta').data('checkoutanalyticsdata');
        tealiumEnable.getAnalyticsData('initiateRegularCheckout', checkoutMethod, initiateCheckoutData, subTotal, totalItems);
        $.spinner().start();
        if (!sessionStorage.getItem('loqateTriggeredOnce')) {
            sessionStorage.setItem('loqateTriggeredOnce', 'false');
        }
        if ($('#siteName').val() !== 'pvhckca') {
            if (rememberedGuestUser) {
                var sessionTimeoutUrl = $('.checkout-sessionTimeout-url').val();
                $('.checkout-sessionTimeout-url').val(`${sessionTimeoutUrl}?proceedrememberedGuestUser=true`);
                if (queryParam.paymentMethod === 'expressPayment') {
                    window.location.href = `${$('.initiate-checkout_js').data('cartpage')}?proceedrememberedGuestUser=true`;
                } else {
                    window.location.href = `${$this.data('href')}?proceedrememberedGuestUser=true`;
                }
            } else {
                if ($(this).data('autenticateduser') === true) { // eslint-disable-line
                    $this.data('lastclicked', true);
                    window.location.href = $this.data('href');
                } else {
                    if (checkoutMethod === 'guest checkout') {
                        $this.data('lastclicked', true);
                    }
                    $.spinner().stop();
                }
            }
        }
        $.spinner().stop();
        return true;
    });

    $(function () {
        const $mainRecs = $('.cart-main-recommendations');
        const $emptyRecs = $('.cart-empty-recommendations');
        const $hasCartItems = $('.cart.cart-page.has-cart-items');

        if ($hasCartItems.length > 0) {
            $mainRecs.removeClass('d-none');
        } else {
            $emptyRecs.removeClass('d-none');
        }
    });

    $(function () {
        $('select').each(function () {
            $(this).val($(this).find('option[selected]').val());
        });
    });

    $(function () {
        if (window.location.href.indexOf('redemptionError') > -1) {
            showRewardsUnavailableMsg();
        }
        if (window.location.href.indexOf('rewardsError') > -1) {
            showRewardsErrorMsg();
        }
        if (window.location.href.indexOf('serviceError') < 0 && $('.showErrorMessage').length && $('.showErrorMessage').attr('data-antavoerrormsg') === 'true') {
            $('#registered-eligible-message .page-error').removeClass('d-none');
        }
        if (window.location.href.indexOf('serviceError') > -1) {
            showServiceErrorMsg();
        }
        if ($('.checkout-button-preview').length > 0) {
            if ($('.checkout-button-preview').offset().top >= $('.checkout-continue').offset().top) {
                $('.checkout-button-preview').css('bottom', '-80px');
            } else {
                $('.checkout-button-preview').css('bottom', '0px');
            }
        }
        cartCustomService.cartCheckoutShowHideItems();

        if ($('#js_paypal_button').length) {
            $('#js_paypal_button').html('<svg class="paypal-express"><use xlink:href="#paypal-ds"></use></svg><span class="d-none">Paypal</span');
        }
    });

    $(document).on('scroll', function () {
        if (currentPage === 'cart' && $('.checkout-button-preview').length > 0) {
            if ($('.checkout-button-preview').offset().top >= $('.checkout-continue').offset().top) {
                $('.checkout-button-preview').css('bottom', '-80px');
            } else {
                $('.checkout-button-preview').css('bottom', '0px');
            }
        }
    });

    $(cartCustomService.removeRepeatedPromoMessage);

    if (window.dw
        && window.dw.applepay
        && window.ApplePaySession
        && window.ApplePaySession.canMakePayments()) {
        $('body').addClass('apple-pay-enabled');
    }

    base.removeBonusProduct();
    base.selectBonusProduct();
    base.enableBonusProductSelection();
    base.showMoreBonusProducts();
    base.addBonusProductsToCart();
    base.focusChooseBonusProductModal();
    base.trapChooseBonusProductModalFocus();
    base.onClosingChooseBonusProductModal();
    showEditOrderMsg();
    if ($('.klarna-express-checkout').length > 0) {
        klarnaExpress();
    }

    $('.learn-how-txt').on('click', function () {
        var learnHowCta = {
            event_name: 'site_interaction',
            site_interaction: 'cart:order summary:loyalty-learn how'
        };
        tealiumEnable.getAnalyticsData('learnHowEvent', learnHowCta);
    });
    utils.uniformSpacing();
};
